import React from 'react'
import App from './App'
import { ContextProvider } from '@monorepo/service'
import { ApmProvider } from '@monorepo/service'
import { GeoRuntimeProvider } from '../../geo/context'

const Page = () => (
  <ApmProvider>
    <ContextProvider>
      <GeoRuntimeProvider>
        <App />
      </GeoRuntimeProvider>
    </ContextProvider>
  </ApmProvider>
)

export default Page
